import { styled } from '@mui/material/styles';
import { TableCell, tableCellClasses } from '@mui/material';

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.background.default
    }
}));
export const StickyTableHeadCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.background.default,
        position: 'sticky',
        right: 0,
        top: 0,
        zIndex: 1000
    }
}));
export const StickyTableCell = styled(TableCell)(({ theme }) => ({
    position: 'sticky',
    right: 0,
    zIndex: 1,
    backgroundColor: theme.palette.background.default
}));